import { RefObject, useCallback, useEffect, useRef } from 'react'
import { OccasionalSlotsValidationErrors } from '../../models/occasionalSlotsValidation'
import { AnyBlockLine, ERROR_FIELD_BY_BLOCK, AnyFormBlock } from '../constants/blockByType'

// The lines are given in display order, and the blocks of a line from left to right
export function getFirstErrorBlock(
    errors: OccasionalSlotsValidationErrors,
    lines: AnyBlockLine[]
): AnyFormBlock | undefined {
    return lines.flat().find((block: AnyFormBlock): boolean => {
        const errorField: keyof OccasionalSlotsValidationErrors | undefined = ERROR_FIELD_BY_BLOCK[block]
        return errorField !== undefined && errors[errorField]
    })
}

export function useScrollToFirstError(
    errors: OccasionalSlotsValidationErrors,
    validationAttempt: number,
    lines: AnyBlockLine[]
) {
    const blockElements: RefObject<Partial<Record<AnyFormBlock, HTMLElement | null>>> = useRef<
        Partial<Record<AnyFormBlock, HTMLElement | null>>
    >({})

    const registerBlock: (block: AnyFormBlock) => (element: HTMLElement | null) => void = useCallback(
        (block: AnyFormBlock) =>
            (element: HTMLElement | null): void => {
                blockElements.current[block] = element
            },
        []
    )

    // Runs after the commit, so the blocks (and the "more options" part) are already rendered
    useEffect(() => {
        if (validationAttempt === 0) return
        const firstErrorBlock: AnyFormBlock | undefined = getFirstErrorBlock(errors, lines)
        if (firstErrorBlock) {
            blockElements.current[firstErrorBlock]?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
        // Only a new validation attempt should scroll, not every change of errors
    }, [validationAttempt])

    return { registerBlock }
}
